import type { AuthUserEntity } from '@/entities/types.ts';
import type { SentryAuthUser } from '@/plugins/sentry.ts';

type AuthUserTelemetryFields = AuthUserEntity & {
    email?: string | null;
    first_name?: string | null;
    last_name?: string | null;
};

const buildSentryAuthUser = (user: AuthUserEntity | null): SentryAuthUser | null => {
    if (!user?.id) {
        return null;
    }

    const telemetryUser = user as AuthUserTelemetryFields;

    return {
        id: user.id,
        email: telemetryUser.email ?? '',
        first_name: telemetryUser.first_name ?? '',
        last_name: telemetryUser.last_name ?? '',
    };
};

const buildBehaviorAuthUser = (user: AuthUserEntity | null): Record<string, unknown> | null => {
    if (!user) {
        return null;
    }

    return user as unknown as Record<string, unknown>;
};

const buildNewRelicAuthUser = (
    user: AuthUserEntity | null
): {
    id?: string | number;
    account_id?: string | number;
} | null => {
    if (!user) {
        return null;
    }

    return {
        id: user.id ?? undefined,
        account_id: user.account_id ?? undefined,
    };
};

export { buildBehaviorAuthUser, buildNewRelicAuthUser, buildSentryAuthUser };
